import type { ReactNode } from "react";
import { Paper, Stack, Text, Title } from "@mantine/core";

/**
 * A titled config card. The product-config form is a vertical stack of these,
 * each grouping one slice of the ProductConfigPayload (identity & targeting,
 * master sheet, naming, scheduled conversion). Composed from Mantine
 * `Paper`/`Title`/`Text` (U6); the heading stays a real level-2 `<h2>` so the
 * config screens' heading-level assertions hold.
 */
export function Section({
  title,
  description,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Paper component="section" withBorder radius="md" p="lg">
      <Stack gap="md">
        <Stack gap={4}>
          <Title order={2} fz="md" fw={600}>
            {title}
          </Title>
          {description && (
            <Text c="dimmed" fz="sm">
              {description}
            </Text>
          )}
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
}
